export default __webpack_public_path__ + "static/Roboto-Italic-7b9923bbf8996da54770123b1b80c2d1.ttf";